import { globals, template } from '@yola/ws-sdk';
import constants from 'src/js/modules/website-settings/constants/common';
import saveSite from 'src/js/modules/saving/helpers/save-site';
import store from '../../../store';

const deleteLanguageSelector = () => {
  const state = store.getState();
  const { globalId } = template.selectors.getVariableValueByPath(state, 'languageSelector[0]');
  const languageSelector = document.createElement(constants.LANGUAGE_SELECTOR_TAG);
  languageSelector.hidden = true;

  store.dispatch(globals.actions.setGlobalHTML(globalId, languageSelector.outerHTML));
  saveSite();
};

export default deleteLanguageSelector;
